import { useEffect, useState } from 'react';

import { useGetPersonalDataAgreementQuery, useGetPrivacyPolicyQuery, useGetUserAgreementQuery } from 'store/api';

const PdfHandler = () => {
	const { data: pdfBlobPolicy } = useGetPrivacyPolicyQuery();
	const [pdfUrlPolicy, setPdfUrlPolicy] = useState<string | undefined>();

	const { data: pdfBlobUserAgreement } = useGetUserAgreementQuery();
	const [pdfUrlUserAgreement, setPdfUrlUserAgreement] = useState<string | undefined>();

	const { data: pdfBlobPersonalDataAgreement } = useGetPersonalDataAgreementQuery();
	const [pdfPersonalDataAgreement, setPdfPersonalDataAgreement] = useState<string | undefined>();

	const [openModal, setOpenModal] = useState(false);
	const [openModalPolicy, setOpenModalPolicy] = useState(false);
	const [openModalPersonalDataAgreement, setOpenPersonalDataAgreement] = useState(false);

	useEffect(() => {
		if (pdfBlobPolicy) {
			const url = URL.createObjectURL(pdfBlobPolicy);
			setPdfUrlPolicy(url);

			return () => {
				URL.revokeObjectURL(url);
			};
		}
	}, [pdfBlobPolicy]);

	useEffect(() => {
		if (pdfBlobUserAgreement) {
			const url = URL.createObjectURL(pdfBlobUserAgreement);
			setPdfUrlUserAgreement(url);

			return () => {
				URL.revokeObjectURL(url);
			};
		}
	}, [pdfBlobUserAgreement]);

	useEffect(() => {
		if (pdfBlobPersonalDataAgreement) {
			const url = URL.createObjectURL(pdfBlobPersonalDataAgreement);
			setPdfPersonalDataAgreement(url);

			return () => {
				URL.revokeObjectURL(url);
			};
		}
	}, [pdfBlobPersonalDataAgreement]);

	const handleOpenModal = (e: React.MouseEvent<HTMLAnchorElement>) => {
		e.preventDefault();
		setOpenModal(true);
	};

	const handleOpenModalPrivacy = (e: React.MouseEvent<HTMLAnchorElement>) => {
		e.preventDefault();
		setOpenModalPolicy(true);
	};

	const handleOpenModalPersonal = (e: React.MouseEvent<HTMLAnchorElement>) => {
		e.preventDefault();
		setOpenPersonalDataAgreement(true);
	};

	const handleCloseModal = () => {
		setOpenModal(false);
	};

	const handleCloseModalPrivacy = () => {
		setOpenModalPolicy(false);
	};

	const handleCloseModalPersonal = () => {
		setOpenPersonalDataAgreement(false);
	};

	return {
		pdfBlobPolicy,
		pdfUrlPolicy,
		pdfBlobUserAgreement,
		pdfUrlUserAgreement,
		pdfBlobPersonalDataAgreement,
		pdfPersonalDataAgreement,
		openModal,
		openModalPolicy,
		openModalPersonalDataAgreement,
		handleOpenModal,
		handleOpenModalPrivacy,
		handleOpenModalPersonal,
		handleCloseModal,
		handleCloseModalPrivacy,
		handleCloseModalPersonal,
	};
};

export default PdfHandler;
